import request from '@/utils/request'

export function scheduleEventsBatch(data) {
  return request({
    url: '/api/scheduled-events/batch',
    method: 'put',
    data: {
      events: data
    }
  })
}

export function getScheduledRedirectEvents(id) {
  return request({
    url: `/api/scheduled-events?context=REDIRECT&contextId=${id}`,
    method: 'get'
  })
}

export function getScheduledInsertEvents(id) {
  return request({
    url: `/api/scheduled-events?context=INSERT&contextId=${id}`,
    method: 'get'
  })
}

export function deleteScheduledRedirectEvent(type, contextId) {
  return request({
    url: `/api/scheduled-events/${type}/${contextId}`,
    method: 'delete'
  })
}

export function getScheduledEvents(rootId) {
  return request({
    url: `/api/scheduled-events/by-rootcontext/${rootId}`,
    method: 'get'
  })
}

export function getScheduledNotificationEvents() {
  return request({
    url: '/api/scheduled-events?context=NOTIFICATION',
    method: 'get'
  })
}

export function getScheduledNotificationEventById(contextId) {
  return request({
    url: `/api/scheduled-events?context=NOTIFICATION&contextId=${contextId}`,
    method: 'get'
  })
}

export function deleteScheduledNotificationEventById(contextId) {
  return request({
    url: `/api/scheduled-events/SEND_NOTIFICATIONS/${contextId}`,
    method: 'delete'
  })
}

export function getDeactivateLeafletScheduledEvent(contextId) {
  return request({
    url: `/api/scheduled-events?contextId=${contextId}&context=LEAFLET`,
    method: 'get'
  })
}

export function deleteDeactivateLeafleScheduledEvent(contextId) {
  return request({
    url: `/api/scheduled-events/DEACTIVATE_LEAFLET/${contextId}`,
    method: 'delete'
  })
}

export function uploadNotificationImage(id, type, time, data) {
  return request({
    url: `/api/notifications/img?id=${id}&type=${type}&time=${time}`,
    method: 'post',
    data
  })
}
